export const ATUALIZAR_AVISO = 'ATUALIZAR_AVISO';
export const atualizarAviso = (mensagem, tipo) => ({
  type: ATUALIZAR_AVISO,
  payload: {
    mensagem,
    tipo,
  },
});



// WEBPACK FOOTER //
// ./src/app/common/avisos/avisos.action.js